import { createRouter, createWebHistory } from "vue-router";

import authRoutes from "@/router/auth";
import userRoutes from "@/router/user";
import globalRoutes from "@/router/global";
import settingsRoutes from "@/router/settings";

const routes = [authRoutes, userRoutes, settingsRoutes, ...globalRoutes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

const middlewareFactory = (context, middlewares, index) => {
  const nextMiddleware = middlewares[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextMiddlewareFn = middlewareFactory(context, middlewares, index + 1);

    nextMiddleware({ ...context, next: nextMiddlewareFn });
  };
};

router.beforeEach((to, from, next) => {
  if (window.location !== window.parent.location) return next();

  if (to.meta.middlewares) {
    const middlewares = to.meta.middlewares;

    const nextMiddleware = middlewareFactory(
      { from, next, router, to },
      middlewares,
      0
    );

    return nextMiddleware();
  }

  return next();
});

export default router;
